/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiScreeningHitAiInsight
 */
export interface ApiScreeningHitAiInsight {
    /**
     * 
     * @type {boolean}
     * @memberof ApiScreeningHitAiInsight
     */
    areNamesEqual: boolean;
    /**
     * 
     * @type {string}
     * @memberof ApiScreeningHitAiInsight
     */
    context: string;
}

/**
 * Check if a given object implements the ApiScreeningHitAiInsight interface.
 */
export function instanceOfApiScreeningHitAiInsight(value: object): value is ApiScreeningHitAiInsight {
    if (!('areNamesEqual' in value) || value['areNamesEqual'] === undefined) return false;
    if (!('context' in value) || value['context'] === undefined) return false;
    return true;
}

export function ApiScreeningHitAiInsightFromJSON(json: any): ApiScreeningHitAiInsight {
    return ApiScreeningHitAiInsightFromJSONTyped(json, false);
}

export function ApiScreeningHitAiInsightFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScreeningHitAiInsight {
    if (json == null) {
        return json;
    }
    return {
        
        'areNamesEqual': json['areNamesEqual'],
        'context': json['context'],
    };
}

export function ApiScreeningHitAiInsightToJSON(json: any): ApiScreeningHitAiInsight {
    return ApiScreeningHitAiInsightToJSONTyped(json, false);
}

export function ApiScreeningHitAiInsightToJSONTyped(value?: ApiScreeningHitAiInsight | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'areNamesEqual': value['areNamesEqual'],
        'context': value['context'],
    };
}

